import { tv } from 'tailwind-variants'

export const separator = tv({
  slots: {
    container: 'h-px overflow-hidden',
    line: 'border-b border-grey-200',
  },
  variants: {
    lineType: {
      solid: {
        line: 'border-solid',
      },
      dashed: {
        line: 'border-dashed',
      },
    },
  },
  defaultVariants: {
    lineType: 'dashed',
  },
})
